// removed by extract-text-webpack-plugin
module.exports = {"toast":"toast","visible":"visible","close":"close"};


//////////////////
// WEBPACK FOOTER
// ./src/view/common/Toast/style.scss
// module id = 1215
// module chunks = 0